import {
	BaseAPIResponse,
	CreateDriveRegistrationApplicationInput,
	GetAllDrivesAPIResponse,
	GetDriveCandidatesAPIResponse,
	GetDriveCompaniesAPIInput,
	GetDriveCompaniesAPIResponse,
	GetDrivePositionApplicantsAPIResponse,
	GetDrivePositionsAPIInput,
	GetDrivePositionsAPIResponse,
	GetDriveRegistrationApplicationResponse,
	PositionStatus,
	RecruiterFormData,
	RegisterForDriveAPIInput,
	UserAvailabilityInput,
	UserFiltersForApis,
} from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/drive`;

export const getAllDrives = async (data?: {
	showInternalDrives?: boolean;
}): Promise<GetAllDrivesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/all`, { params: data });
	return response.data;
};

export const registerForDrive = async (data: RegisterForDriveAPIInput): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/register`, data);
	return response.data;
};

export const updateDrivePosition = async (id: string, data: RecruiterFormData): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/updateDrivePosition/${id}`, data);
	return response.data;
};

export const getDriveCompanies = async (data?: GetDriveCompaniesAPIInput): Promise<GetDriveCompaniesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/getDriveCompanies`, { params: data });
	return response.data;
};

export const getDrivePositions = async (data?: GetDrivePositionsAPIInput): Promise<GetDrivePositionsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/getDrivePositions`, { params: data });
	return response.data;
};

export const getDriveCandidates = async (
	data?: UserFiltersForApis & { page: number; limit?: number; position?: string },
): Promise<GetDriveCandidatesAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/getDriveCandidates`, data);
	return response.data;
};

export const getDrivePositionApplicants = async (
	data?: UserFiltersForApis & { page: number; limit?: number; position?: string },
): Promise<GetDrivePositionApplicantsAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/getDrivePositionApplicants`, data);
	return response.data;
};

export const shortlistDriveCandidate = async (data: {
	userId: string;
	positionId: string;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/shortlistCandidate`, data);
	return response.data;
};

export const closeDrivePosition = async (data: { positionId: string; reason: string }): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/closeDrivePosition/${data.positionId}`, {
		reason: data?.reason,
		status: PositionStatus.CLOSED,
	});
	return response.data;
};

export const createDriveRegistrationApplication = async (
	driveApplication: CreateDriveRegistrationApplicationInput,
): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create-drive-registration-application`, driveApplication);
	return response.data;
};

export const getDriveRegistrationApplication = async (): Promise<GetDriveRegistrationApplicationResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-drive-registration-application-status`);
	return response.data;
};

export const startDriveRegistrationAssessment = async (data: {
	driveApplicationId: string;
	isMock: boolean;
}): Promise<BaseAPIResponse & { url: string }> => {
	const response = await baseApi.post(`${baseUrl}/start-drive-registration-assessment`, data);
	return response.data;
};

export const driveRegistrationScheduleCounselling = async (data: {
	driveApplicationId: string;
	selectedCounsellingSlot: UserAvailabilityInput;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/drive-registration-schedule-counselling`, data);
	return response.data;
};
